.root {
  border: 1px solid var(--line);
  border-radius: 13px;
  background: var(--panel);
  box-shadow: var(--shadow-wdg);
  animation: 0.4s var(--ease) both;
  /* global(): иначе имя захешируется и анимация не сыграет — см. shared/styles/animations.css */
  animation-name: global(wdg-in);

  /*
   * Ступенчатая задержка появления: в макете секции карточки брони выезжают каскадом
   * (0s · .05s · .1s · .15s · .2s · .25s — prototype/Prototype.dc.html:1491).
   *
   * Задаётся КАСТОМНЫМ СВОЙСТВОМ, а не классом потребителя с `animation-delay`, — и это не
   * стилистика, а единственный способ, который не разваливается:
   *
   *   1. Шорткат `animation` выше СБРАСЫВАЕТ `animation-delay` в 0s. Если потребитель поставит
   *      свой `animation-delay` в своём классе, победит тот, чей файл окажется НИЖЕ в собранном
   *      CSS: специфичность равна (один класс против одного), а `.root` и класс потребителя
   *      лежат в РАЗНЫХ чанках (`ui-*.css` и `index-*.css`). Порядок их подключения — не то,
   *      на что стоит опираться (тот же капкан уже описан у `.sectionSkeleton` в
   *      `widgets/booking-modal`).
   *   2. Кастомное свойство шорткат `animation` не трогает вовсе — оно не является его
   *      составной частью. Значит `--wdg-delay` от потребителя доезжает сюда при любом порядке
   *      чанков, а longhand ниже сам перекрывает ноль, выставленный шорткатом.
   *
   * Проверяется грепом по собранному CSS: `animation-name: wdg-in` обязано резолвиться,
   * а `--wdg-delay` — доехать. См. HANDOFF §5, «Глобальный keyframe … не работает без global()».
   */
  animation-delay: var(--wdg-delay, 0s);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 18px 0;
}

.eyebrow {
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ink-3);
}

.aside {
  flex-shrink: 0;
}
